import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = {
  class: "ofh kakugo w100 posFi shadowContent messageHeader skyblueBg",
  style: {"top":"0","z-index":"10"}
}
const _hoisted_3 = {
  key: 0,
  class: "ofh w14 fl navBarReturn whiteColor",
  style: {"background":"#111"}
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  class: "ofh fl ml15",
  style: {}
}
const _hoisted_7 = { class: "fs13 whiteColor" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "w100"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = {
  key: 0,
  class: "posFi w100 llgreyBg z1",
  style: {"height":"40px","top":"108px","padding-left":"40px"}
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CalendarThumbnailContent = _resolveComponent("CalendarThumbnailContent")!
  const _component_AstagSearchBox = _resolveComponent("AstagSearchBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      (_ctx.href && !_ctx.href.includes(`/start`) && _ctx.showBackButton)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickBack && _ctx.clickBack(...args)))
            }, [
              _createElementVNode("p", {
                class: _normalizeClass(`kakugo pointer ${_ctx.isSP ? 'fs13' : 'ls1 fs13'}`),
                style: {"margin-left":"20px","margin-top":"0","line-height":"68px"}
              }, [
                _createElementVNode("span", null, [
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/leftArrow_lgrey.png`),
                    width: "15",
                    height: "19",
                    style: {"margin-top":"-4px"}
                  }, null, 8, _hoisted_4),
                  (!_ctx.isSP)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, "戻る"))
                    : _createCommentVNode("", true)
                ])
              ], 2)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.cm.voteViewType != `complete`)
          ? (_openBlock(), _createBlock(_component_CalendarThumbnailContent, {
              key: 0,
              onEditAstag: _ctx.editAstag,
              clickChangeName: _ctx.clickChangeName,
              clickChangeAutoMode: _ctx.clickChangeAutoMode
            }, null, 8, ["onEditAstag", "clickChangeName", "clickChangeAutoMode"]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.buttonTitle && !_ctx.isSuspend)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            type: "submit",
            class: _normalizeClass(`circle_button ${_ctx.buttonEnabled ? `pinkBg fffColor` : `greyBg grey`} fr centered fw600 ${
                    _ctx.cm.astag && _ctx.cm.astag.is_shared && _ctx.cm.astag.owner ? `mr50` : `mr20`
                }  mt17 padw6`),
            style: _normalizeStyle({
                    position: _ctx.isSP ? `absolute` : `relative`,
                    right: _ctx.isSP ? `5px` : ``,
                    top: _ctx.isSP ? `12px` : ``,
                    minWidth: _ctx.isSP ? `` : `140px`,
                    border: `1px solid ${_ctx.buttonEnabled ? `#3c3f98` : `#828282`}`,
                }),
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickPinkButton && _ctx.clickPinkButton(...args)))
          }, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.buttonTitle), 1)
          ], 6))
        : _createCommentVNode("", true),
      (_ctx.cm.createType == `vote` && _ctx.cm.voteViewType != `complete`)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "fr whiteColor fs12 underline pointer mt20 mr15 pad5 w600",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickHowToSelect && _ctx.clickHowToSelect(...args)))
          }, " 候補の選び方 "))
        : _createCommentVNode("", true),
      _hoisted_8
    ]),
    _createElementVNode("section", {
      class: "posFi w100 with_white_bg centered fw600",
      style: _normalizeStyle({
                top: _ctx.isSP ? `60px` : `68px`,
                height: `40px`,
                lineHeight: `40px`,
                boxShadow: `10px 5px 17px #ddd`,
                zIndex: 2,
                display: `flex`,
                justifyContent: `left`,
                paddingLeft: `90px`,
            })
    }, [
      (_ctx.from == `asview`)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", {
              class: _normalizeClass(`settingsCategoryTab fl pointer ${_ctx.selectedTabName == `list` ? `selected` : ``}`),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectTab(`list`)))
            }, [
              _createElementVNode("img", {
                src: _ctx.$getAssetImageUrl(`/assets/icons/pageicon.png`),
                width: "13",
                height: "13",
                style: {"margin-top":"-2px"}
              }, null, 8, _hoisted_10),
              _createTextVNode("   一覧 ")
            ], 2),
            (_ctx.cm.astag)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(`settingsCategoryTab fl pointer ${_ctx.selectedTabName == `detail` ? `selected` : ``}`),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectTab(`detail`)))
                }, [
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/lines4.png`),
                    width: "18",
                    height: "16",
                    style: {"margin-top":"-3px"}
                  }, null, 8, _hoisted_11),
                  _createTextVNode("  編集中の調整カレンダー ")
                ], 2))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_12)),
      _hoisted_13
    ], 4),
    (_ctx.selectedTabName == `list`)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", {
            class: _normalizeClass(`fs12 mt2 fl pointer pad10 ${_ctx.astagsTab?.tab_name == `default` ? `fw600 selected` : ``}`),
            style: {"width":"220px"},
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeCategoryTab(`default`)))
          }, " 自分が作成した調整カレンダー ", 2),
          _createElementVNode("div", {
            class: _normalizeClass(`fs12 mt2 fl pointer pad10 ${_ctx.astagsTab?.tab_name == `shared` ? `fw600 selected` : ``}`),
            style: {"width":"220px"},
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeCategoryTab(`shared`)))
          }, " 共有を受けている調整カレンダー ", 2),
          _createVNode(_component_AstagSearchBox, {
            class: "fr mr20",
            style: {"height":"40px"},
            canSelectShared: true
          }),
          _hoisted_15
        ]))
      : _createCommentVNode("", true)
  ]))
}